import { FC } from 'react'

import Button from 'core/components/lib/Button'

import { ErrorMessage, ErrorTitle, FallbackProps, WarningBox } from './defaultErrorBoundaries'

export type TimeoutErrorProps = FallbackProps & {
  operation?: string
  reset: () => void
}

const DefaultTimeoutErrorFallback: FC<TimeoutErrorProps> = ({ className, operation, reset }) => (
  <WarningBox className={className}>
    <ErrorTitle>Timed out</ErrorTitle>
    <ErrorMessage>
      {operation ? `This request has timed out: ${operation}. ` : 'A request has timed out. '}
      Would you like to{' '}
      <Button inline onClick={reset}>
        try again
      </Button>{' '}
      or{' '}
      <Button inline onClick={() => window.location.reload()}>
        reload the page
      </Button>
      ?
    </ErrorMessage>
  </WarningBox>
)

export default DefaultTimeoutErrorFallback
